import { type GetHookResponse } from '../hooks'
import { locationPrescreenKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useLocationCache } from './cache'
import {
  Logger,
  type PrescreenDecision,
  DAY,
  type LocationPrescreenInput,
  type LocationPrescreenSuccess,
} from '@terros/common'

const logger = new Logger('prescreen')

export function usePrescreen(
  input: LocationPrescreenInput,
  onPrescreen?: (res: LocationPrescreenSuccess) => void
): GetHookResponse<PrescreenDecision> {
  logger.verbose('calling usePrescreen')
  const { updatePrescreen } = useLocationCache()

  return useTantalimQuery<LocationPrescreenInput, LocationPrescreenSuccess, PrescreenDecision>({
    url: '/location/prescreen',
    queryKey: locationPrescreenKey(input),
    input,
    convertResponse: (res) => {
      updatePrescreen(input.locationId)
      onPrescreen?.(res)
      return res.decision
    },
    options: {
      enabled: false,
      gcTime: DAY,
      staleTime: DAY,
      retry: false,
    },
  })
}
